/* eslint-disable import/prefer-default-export */
export const getTopPosition = () => window.pageYOffset || document.documentElement.scrollTop;

export const isIframe = () => window.self !== window.top;
